import { Outlet, type RouteObject } from 'react-router-dom';
import { RequireAuth } from '@/auth/RequireAuth';
import type { RouteHandle } from '@/layout/routeHandle';
import { VoyageDetailPage } from './VoyageDetailPage';
import { VoyageFormPage } from './VoyageFormPage';
import { VoyageListPage } from './VoyageListPage';

/** voyage-reports（担当: G2）。パスは `/years/:year` からの相対。S-40〜S-42 */
export const routes: RouteObject[] = [
  {
    path: 'voyage-reports',
    handle: { crumb: '速報' } satisfies RouteHandle,
    element: <Outlet />,
    children: [
      { index: true, element: <VoyageListPage /> },
      {
        path: 'new',
        element: (
          <RequireAuth roles={['基金', '漁協']}>
            <VoyageFormPage />
          </RequireAuth>
        ),
        handle: { crumb: '新規登録' } satisfies RouteHandle,
      },
      { path: ':id', element: <VoyageDetailPage />, handle: { crumb: '詳細' } satisfies RouteHandle },
      {
        path: ':id/edit',
        element: (
          <RequireAuth roles={['基金', '漁協']}>
            <VoyageFormPage />
          </RequireAuth>
        ),
        handle: { crumb: '編集' } satisfies RouteHandle,
      },
    ],
  },
];
